import { Table as MuiTable, TableProps } from '@mui/material';

const Table = (props: TableProps) => {
  return <MuiTable {...props} />;
};

export default Table;
